import { Divider, Grid, LinearProgress, TextField, Tooltip, Typography } from "@mui/material";
import { LanguageOutlined } from "@mui/icons-material";
import { removeMask } from "../../../../../../utils/masks";

// Seção "Configuração de Rede" do formulário de circuito. Puramente apresentacional
// (sem estado próprio) — extraído de circuito/index.js (etapa 19, passo 3, do plano
// de melhorias), mesmo JSX/comportamento, só movido de arquivo.
export default function RedeSection({
  styles,
  formData,
  editMode,
  loading,
  loadingSerial,
  errors,
  handleChange,
  validateBlocoAndIp,
  setSnackbar,
}) {
  return (
    <>
      <Grid item xs={12} sx={styles.gritItemTitle}>
        <LanguageOutlined color="primary" />
        <Typography variant="mySubtitle2">Configuração de Rede</Typography>
      </Grid>

      <Grid container spacing={1} sx={styles.contentIdentation}>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            sx={styles.textField}
            disabled={!editMode || loading}
            id="BlocoIp"
            fullWidth
            label="Bloco de IP"
            name="blockIP"
            size="small"
            value={formData?.blockIP}
            onBlur={() => validateBlocoAndIp()}
            onChange={(e) => {
              e.target.value = e.target.value?.replace(
                /[^0-9a-fA-F:./]/g,
                "",
              );
              handleChange(e);
            }}
            error={errors?.blockIP}
            helperText={errors?.blockIP && "Bloco inválido"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            sx={styles.textField}
            disabled={!editMode || loading}
            id="IpPublico"
            fullWidth
            label="IP Público"
            name="ipPublico"
            size="small"
            value={formData?.ipPublico}
            onBlur={() => validateBlocoAndIp()}
            onChange={handleChange}
            error={errors?.ipPublico}
            helperText={errors?.ipPublico && "IP inválido"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3} position={"relative"}>
          {!!loadingSerial && <LinearProgress sx={styles.linearProgress} />}

          <TextField
            sx={styles.textField}
            disabled={!editMode || loading || loadingSerial}
            autoComplete="off"
            fullWidth
            label="Serial"
            name="serial"
            size="small"
            value={formData?.serial}
            onChange={(e) => {
              // Remove espaços e caracteres especiais, mantendo apenas letras e números
              e.target.value = e.target.value.replace(/[^a-zA-Z0-9]/g, "");
              handleChange(e);
            }}
            onBlur={(e) => {
              // Valida se tem exatamente 16 caracteres
              if (
                e.target.value.length > 16 ||
                (e.target.value.length < 12 && e.target.value.length > 0)
              ) {
                setSnackbar({
                  children: "Serial deve ter entre 12 e 16 caracteres",
                  severity: "error",
                });
              }
            }}
            error={
              formData?.serial?.length > 0 &&
              (formData?.serial?.length > 16 || formData?.serial?.length < 12)
            }
            helperText={
              formData?.serial?.length > 0 &&
              (formData?.serial?.length > 16 || formData?.serial?.length < 12)
                ? "Serial deve ter entre 12 e 16 caracteres"
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Tooltip>
            <TextField
              sx={styles.textField}
              disabled={!editMode || loading}
              autoComplete="off"
              fullWidth
              label="VLAN (ID)"
              name="vlanId"
              size="small"
              value={formData?.vlanId}
              onChange={(e) => {
                e.target.value = removeMask(e.target.value);
                handleChange(e);
              }}
            />
          </Tooltip>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            sx={styles.textField}
            disabled={!editMode || loading}
            id="LocalIPV4"
            fullWidth
            label="IPV4 - Local"
            name="companySideIPv4"
            value={formData?.companySideIPv4}
            size="small"
            onBlur={() => validateBlocoAndIp()}
            onChange={handleChange}
            error={errors?.companySideIPv4}
            helperText={errors?.companySideIPv4 && "Ip inválido"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            sx={styles.textField}
            disabled={!editMode || loading}
            autoComplete="off"
            fullWidth
            label="IPV4 - Cliente"
            name="clientIPv4"
            size="small"
            value={formData?.clientIPv4}
            onBlur={() => validateBlocoAndIp()}
            onChange={handleChange}
            error={errors?.clientIPv4}
            helperText={errors?.clientIPv4 && "Ip inválido"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            sx={styles.textField}
            disabled={!editMode || loading}
            id="LocalIPV6"
            fullWidth
            label="IPV6 - Local"
            name="companySideIPv6"
            value={formData?.companySideIPv6}
            size="small"
            onBlur={() => validateBlocoAndIp()}
            onChange={handleChange}
            error={errors?.companySideIPv6}
            helperText={errors?.companySideIPv6 && "Ip inválido"}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            sx={styles.textField}
            disabled={!editMode || loading}
            autoComplete="off"
            fullWidth
            label="IPV6 - Cliente"
            name="clientIPv6"
            size="small"
            value={formData?.clientIPv6}
            onBlur={() => validateBlocoAndIp()}
            onChange={handleChange}
            error={errors?.clientIPv6}
            helperText={errors?.clientIPv6 && "Ip inválido"}
          />
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Divider />
      </Grid>
    </>
  );
}
